module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-check dawn-checkbox"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', _vm._b({
    staticClass: "form-check-input",
    attrs: {
      "id": _vm.optionLabel,
      "name": _vm.name,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.optionStatus,
      "value": _vm.optionStatus
    },
    on: {
      "click": _vm.changeStatus
    }
  }, 'input', _vm.$props, false)), _vm._v(_vm._s(_vm.optionLabel))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f16537e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edCheckbox/checkbox.vue
// module id = KrAn
// module chunks = 13 14